import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CNConsultation } from 'src/app/models/cnconsultation';
import { CNContactRXImage } from 'src/app/models/cncontactrximage';
import { CNContactRXSerie } from 'src/app/models/cncontactrxserie';
import { CNPatient } from 'src/app/models/cnpatient';
import { ImagingService } from 'src/app/services/imaging.service';
import { WaitingDialogComponent } from '../../waiting-dialog/waiting-dialog.component';
import { BecareConfigService } from 'src/app/services/becare-config.service';

@Component({
  selector: 'app-rx-serie-dialog',
  templateUrl: './rx-serie-dialog.component.html',
  styleUrls: ['./rx-serie-dialog.component.scss']
})
export class RxSerieDialogComponent implements OnInit {

  public patient: CNPatient;
  public contact: CNConsultation;
  public serie: CNContactRXSerie;
  public images: CNContactRXImage[];
  public selectedImage: CNContactRXImage;
  public baseurl: string;

  constructor(private dialog: MatDialog, private dialogRef: MatDialogRef<RxSerieDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any, private imaging: ImagingService,
              private becareConfig: BecareConfigService) {
    if (data && data.serie) {
      this.patient = data.patient;
      this.contact = data.contact;
      this.serie = data.serie;
    }
  }

  ngOnInit(): void {
    // Load serie images
    this.imaging.rxSerieImages(this.patient, this.contact, this.serie).subscribe((resultSerie) => {
      this.serie = resultSerie;
    });
  }

  openDicomViewer() {
    // call becare to import the serie in orthanc
    // then open OHIF viewer with serie id returned from becare call
    const waitDailogData = {
      data: {
        title: 'Envoi en cours ...',
        error: undefined,
        result: undefined
      }
    };
    const waitDialog = this.dialog.open(WaitingDialogComponent, waitDailogData);
    this.imaging.sendToPacs(this.serie).subscribe(studies => {
      this.becareConfig.globalProfileValues('ViewerRX','rxviewer').subscribe(result => {
        window.open(result.values[0] + '/viewer/?StudyInstanceUIDs=' + studies[0],'_blank');
        setTimeout(() => {
          waitDialog.close();
        }, 2000);  
      });
    }, error => {
      setTimeout(() => {
        waitDialog.close();
      }, 2000);
    });
  }

  showImage(image: CNContactRXImage): void {
    this.selectedImage = image;
  }

  close() {
    this.dialogRef.close();
  }

}
